<template>
  <div class="check-box" v-bind="$attrs" v-on="$listeners">
    <CheckIcon v-if="checked" class="check" circle :circleColor="color" />
  </div>
</template>

<script>
import CheckIcon from '@/components/icons/CheckIcon'

export default {
  name: 'CheckBox',
  components: {
    CheckIcon,
  },
  props: {
    checked: {
      type: Boolean,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped lang="postcss">
.check-box {
  background: var(--white);
  border-radius: 50%;
  box-shadow: 0 0 0 2px var(--light-gray) inset;
  cursor: pointer;
  height: 20px;
  margin: auto;
  width: 20px;
}
.check {
  height: 20px;
  width: 20px;
}
</style>
